module.exports = __webpack_public_path__ + "static/3-21c91552847b19ec0548d0cffd0b7898.jpg";